import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { DepartmentDataPayload, DepartmentDataResponse } from "@/types/interface/department";

async function createDepartment(payload: DepartmentDataPayload) {
  return await http.post<APIResponse<DepartmentDataResponse>>("department/create", payload);
}

async function updateDepartment(idDepartment = '', payload: DepartmentDataPayload) {
  return await http.patch<APIResponse<DepartmentDataResponse>>(`department/update?id=${idDepartment}`, payload);
}

async function getDepartment(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<DepartmentDataResponse>>(`department?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findDepartment(idDepartment = "") {
  return await http.get<APIResponse<DepartmentDataResponse>>(`department/detail?id=${idDepartment}`);
}

async function deleteDepartment(idDepartment = "") {
  return await http.delete<APIResponse<DepartmentDataResponse>>(`department/delete?id=${idDepartment}`);
}

export default {
  createDepartment,
  updateDepartment,
  getDepartment,
  findDepartment,
  deleteDepartment
};